<div class="email-wrapper">
    <div class="head-tag">
        <h3>{{ 'PROFILE_PAGE.EMAIL_NOTIFICATIONS_TAB.EMAIL_&_NOTIFICATION_PREFERENCES' | transloco }}</h3>
    </div>
    <div>
        <div>
            <!-- <pre>{{item[0]|json}}</pre> -->
            <mat-accordion multi="false" class="informate-expansion-wrapper informate-matrix-expansion-wrapper">
                <mat-expansion-panel *ngFor="let item of datasourceArrayDisplayFiltered(); let i = index">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ item[0]?.groupName }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-panel-description class="panel-description">
                        <!-- <div class="data-wrapper">
              <mat-checkbox class="" (change)="disableAll($event, item)"></mat-checkbox>Disable All
            </div> -->

                        <table class="mat-table div-wrapper mat-table-wrapper w-100" [formGroup]="form.get('emailNotification')">
                            <thead>
                                <tr class="mat-header-row">
                                    <th class="mat-header-cell">{{ 'PROFILE_PAGE.EMAIL_NOTIFICATIONS_TAB.SET_PREFERENCES' | transloco }}</th>
                                    <th class="mat-header-cell">
                                        <mat-checkbox
                                            [disabled]="isEditable == false"
                                            class="example-margin checkbox-wrap"
                                            [checked]="getCheckSelectAllStatus(item)"
                                            [indeterminate]="someComplete(item, 'email')"
                                            (change)="SelectEmailcheckBoxChange($event, item)"
                                        ></mat-checkbox
                                        >{{ 'PROFILE_PAGE.EMAIL_NOTIFICATIONS_TAB.EMAIL' | transloco }}
                                    </th>
                                    <th class="mat-header-cell">
                                        <mat-checkbox
                                            [disabled]="isEditable == false"
                                            class="example-margin checkbox-wrap"
                                            [checked]="getCheckSelectAllStatusNoti(item)"
                                            [indeterminate]="someComplete(item, 'noti')"
                                            (change)="SelectNoticheckBoxChange($event, item)"
                                        ></mat-checkbox>
                                        {{ 'PROFILE_PAGE.EMAIL_NOTIFICATIONS_TAB.NOTIFICATION' | transloco }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="mat-row" *ngFor="let item1 of itemList(item); let j = index">
                                    <td class="mat-cell">
                                        {{ item1?.name }}
                                    </td>
                                    <td class="mat-cell">
                                        <mat-checkbox
                                            [disabled]="isEditable == false"
                                            *ngIf="item1?.email"
                                            class="example-margin checkbox-wrap"
                                            [checked]="item1?.email?.checked"
                                            (change)="checkBoxChange($event, item1.groupName, item1.email, datasourceArrayDisplay)"
                                            [value]="item1?.email?.checked"
                                        ></mat-checkbox>
                                    </td>
                                    <td class="mat-cell">
                                        <mat-checkbox
                                            [disabled]="isEditable == false"
                                            *ngIf="item1?.notification"
                                            class="example-margin checkbox-wrap"
                                            [checked]="item1.notification.checked"
                                            (change)="checkBoxChange($event, item1.groupName, item1.notification, datasourceArrayDisplay)"
                                            [value]="item1.notification.checked"
                                        ></mat-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </mat-panel-description>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
